<template>
  <div id="main-app">
    <ToolBar :title="toolbarTitle" :color="toolbarColor"/>
    <v-progress-linear id="loader" v-bind:indeterminate="true">
      </v-progress-linear>
      
       <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card class="mt-5">
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">Carregando... <br>
                {{user.displayName}},</h3>
                <h5 class="subheading">{{user.email}}</h5>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      
      </div>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
import ToolBar from "@/components/ToolBar";
export default {
  name: "AppBemVindo",
  components: {
    ToolBar
  },
  data() {
    return {
      toolbarTitle: "A5 Convites",
      toolbarColor: "white",
      emailkey: "",
      user: {},
      users_sem_cadastro: {},
      date: moment().format()
    };
  },
  mounted() {
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        // a key não pode ter '.' replace pontos por virgulas
        this.user = user;
        let email = user.email;
        this.emailkey = email.replace(/[.]/g, ",");
        const userRef = this.$db.ref(`users/${this.emailkey}`);

        userRef
          .once("value", snap => {
            if (snap.val() === null) {
              const userSemCadastro = {
                email: user.email,
                date: this.date,
                displayName: user.displayName,
                userID: user.uid
              };
              this.$db
                .ref(`users_sem_cadastro/${this.emailkey}`)
                .set(userSemCadastro);
              this.$router.replace("/semcadastro");
            } else {
              let updates = {};
              let projetoAtual = snap.val().projeto.atual;
              const projetoUserRef = this.$db.ref(
                `projetos/${projetoAtual}/formandos/${this.emailkey}`
              );
              projetoUserRef.child(`/logins`).push({
                login: this.date
              });
              updates[`users/${this.emailkey}/uid`] = user.uid;
              updates[`find/${this.emailkey}/uid`] = user.uid;
              updates[
                `projetos/${projetoAtual}/formandos/${this.emailkey}/uid`
              ] =
                user.uid;
              updates[
                `projetos/${projetoAtual}/formandos/${this.emailkey}/login`
              ] = this.date;
              updates[
                `projetos/${projetoAtual}/formandos/${this.emailkey}/email`
              ] =
                user.email;
              updates[
                `projetos/${projetoAtual}/formandos/${this.emailkey}/photoURL`
              ] =
                user.photoURL;
              this.$db.ref().update(updates);
              this.$router.replace("/dados");
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.$router.replace("/login");
      }
    });
  }
};
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// src/views/AppBemVindo.vue